const apiString = 'https://ktransparencia.kintelligence.com.br';
//const apiString = 'http://localhost';

export default apiString;